import {
  MainDashboardInputs,
  UpdateMainDashboardForAssetRequest,
} from '../../../types/app/asset.types';

export const convertDataFromInputToUpdateRequest = (
  data: MainDashboardInputs,
): UpdateMainDashboardForAssetRequest => ({
  id: data.id,
  qtyLevelGreen: data.qtyLevelGreen,
  qtyLevelOrange: data.qtyLevelOrange,
  showOrangeLevelLine: data.showOrangeLevelLine,
  showActualCycleTime: data.showActualCycleTime,
  showActualState: data.showActualState,
  showScrap: data.showScrap,
  timeAggregation: data.timeAggregation,
  taktTimeLineQty: data.taktTimeLineQty,
  showHydraMachineNumber: data.showHydraMachineNumber,
  showHydraOrderNumber: data.showHydraOrderNumber,
  showHydraToolNumber: data.showHydraToolNumber,
  showHydraPartNumber: data.showHydraPartNumber,
  showHydraStatus: data.showHydraStatus,
});
